import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPredictionsLength,
  selectPromisesLength,
  selectPredictorsLength,
  selectSurveysLength,
  selectIsLoading,
} from "redux-toolkit/dashboard/selectors";
import {
  getPredictionsLengthAsync,
  getPromisesLengthAsync,
  getPredictorsLengthAsync,
  getSurveysLengthAsync,
} from "redux-toolkit/dashboard/actions";

const useDashboard = () => {
  const dispatch = useDispatch();
  const predictionsLength = useSelector(selectPredictionsLength);
  const promisesLength = useSelector(selectPromisesLength);
  const predictorsLength = useSelector(selectPredictorsLength);
  const surveysLength = useSelector(selectSurveysLength);
  const isLoading = useSelector(selectIsLoading);

  useEffect(() => {
    dispatch(getPredictionsLengthAsync());
    dispatch(getPromisesLengthAsync());
    dispatch(getPredictorsLengthAsync());
    dispatch(getSurveysLengthAsync());
  }, [dispatch]);

  return {
    predictionsLength,
    promisesLength,
    predictorsLength,
    surveysLength,
    isLoading,
  };
};

export default useDashboard;
